function isFalsy(me) {
  if (me === 0 || me === null || me === undefined || me === '') {
    return true
  } else {
    return false
  }
}
function isTruthy(me) {
  if (me === 0 || me === null || me === undefined || me === '') {
    return false
  } else {
    return true
  }
}

function isTangible(me) {
  if (isTruthy(me) && me.length > 0) {
    return true
  } else {
    return false
  }
}

function isVacant(me) {
  if (isFalsy(me) || me.length === 0) {
    return true
  } else {
    return false
  }
}

function getFirst(me, where, field) {
  if (isVacant(me)) return null
  const first = me.find(x => where(x))
  if (first) {
    if (field) return first[field]
    return first
  }
  return null
}

function getEnumValue(enumList, key) {
  if (isVacant(enumList)) return ''
  const data = enumList.filter(x => { return x.key == key })
  if (data.length === 0) return ''
  return data[0].value
}

function roundFixed(num, fixed) { // 修改js四舍五入
  if (isFalsy(num)) { num = 0 }
  var pos = num.toString().indexOf('.')
  var decimalplaces = num.toString().length - pos - 1
  var _int = num * Math.pow(10, decimalplaces)
  var divisor1 = Math.pow(10, decimalplaces - fixed)
  var divisor2 = Math.pow(10, fixed)
  return Math.round(_int / divisor1) / divisor2
}

const ext = {
  isFalsy,
  isTruthy,
  isTangible,
  isVacant,
  getFirst,
  getEnumValue,
  roundFixed
}
export default ext
